import React, { Component, PropTypes } from 'react';

import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts';
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import {GridList, GridTile} from 'material-ui/GridList';
import SwipeableViews from 'react-swipeable-views';

import AssignmentIcon from 'material-ui/svg-icons/action/assignment';

import {Tabs, Tab} from 'material-ui/Tabs';
import DashboardIcon from 'material-ui/svg-icons/action/dashboard';
import GraphIcon from 'material-ui/svg-icons/action/timeline';

import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';
import LinearProgress from 'material-ui/LinearProgress';
import moment from 'moment';

import { FetchXHR } from '../Helpers/generals';
import GridValues from './GridValues/GridValues';
import Graphs from './Graphs/Graphs';
import Report from './Report/Report';


import './Dashboard.css';
import DashboardStyles from './DashboardStyles';


const propTypes = {
    apiUrl: PropTypes.string
};

const defaultProps = {
    apiUrl: 'http://localhost:3000'
};

class Dashboard extends Component {
    constructor(props) {
        super(props);;
        this.state = {
            slideIndex: 0,
            loadingData: true,
            initialDate: moment().subtract(7, 'days').toDate(),
            finalDate: moment().toDate(),
            fbConnected: false,
            reportData: [],
            analyticsData: [],
            isFromAnalytics: false
        }

        this.accountName = 'Portal del agua';
        //this.accountName = 'KarmaPulse';

        this.reloadData = this.reloadData.bind(this);
        this.reloadAnalytics = this.reloadAnalytics.bind(this);

        this.changeInitialDate = this.changeInitialDate.bind(this);
        this.changeFinalDate = this.changeFinalDate.bind(this);
        this.handleChangeTab = this.handleChangeTab.bind(this);

        this.checkFacebook = this.checkFacebook.bind(this);
        this.doLoginFB = this.doLoginFB.bind(this);

        this.sendAnalyticsData = this.sendAnalyticsData.bind(this);
    }

    componentDidMount() {
        this.reloadAnalytics();

    }

    doLoginFB() {
        window.FB.login((response) => {
            this.checkFacebook();
        }, { scope: 'read_insights, read_audience_network_insights, manage_pages, pages_show_list, pages_manage_cta, pages_manage_instant_articles, publish_pages'});
    }

    checkFacebook() {
        if (window.FB) {
            const tokenUrl = 'https://agua.org.mx/monitorservice/tokenfb';
            FetchXHR(tokenUrl, 'GET').then((response) => {
                if (Object.keys(response.json.data.token_fb).length !== 0) {
                    this.setState({
                        fbConnected: true
                    });
                } else {
                    window.FB.getLoginStatus((responseSave) => {
                        if(responseSave.status == "connected") {
                            const dataToSend = { token_fb: responseSave.authResponse.accessToken };
                            FetchXHR(tokenUrl, 'POST', dataToSend).then((responsef) => {
                                this.setState({
                                    fbConnected: true
                                });
                            });
                        }else{
                            this.setState({
                                fbConnected: false
                            });
                        }
                    });
                }
            }).catch((onError) => {
                this.setState({
                    fbConnected: false
                });
            });
        }else{
            this.setState({
                fbConnected: false
            });
        }
    }

    handleChangeTab(value) {
        this.setState({
            slideIndex: value,
        });
    };

    reloadData(y, t) {
        const url = 'https://agua.org.mx/monitorservice/parameters';
        const postData = {
            year: y,
            trimester: t
        };
        FetchXHR(url, 'POST', postData).then((response) => {
            if (response.json.data.length > 0) {
                this.setState({
                    isFromAnalytics: false,
                    reportData: response.json.data
                });
            }
        }).catch((onError) => {
            console.log(onError);
        });
    }

    reloadAnalytics() {
        this.setState({
            loadingData: true
        });
        const url = 'https://agua.org.mx/monitorservice/reports';
        console.log(this.state.initialDate);
        console.log(this.state.finalDate);
        // remove hours on date:
        const newInitial = moment(this.state.initialDate).format('YYYY-MM-DDT00:00:00Z');
        const newFinal = moment(this.state.finalDate).format('YYYY-MM-DDT23:59:59Z');
        console.log(newInitial);
        console.log(newFinal);

        const postData = {
            initialDate: newInitial,
            finalDate: newFinal,
        };
        FetchXHR(url, 'POST', postData).then((response) => {
            if (response.json.data.length > 0) {
                this.setState({
                    analyticsData: response.json.data,
                    loadingData: false
                });
                this.checkFacebook();
            }
        }).catch((onError) => {
            console.log(onError);
        });
    }

    changeInitialDate(event, date){
        this.setState({
            initialDate: date,
        });
    }

    changeFinalDate(event, date){
        this.setState({
            finalDate: date,
        });
    }

    sendAnalyticsData() {
        // SEND THE NEW ANALYTICS DATA TO THE COMPONENT AND CHANGE THE TAB:...
        this.setState({
            isFromAnalytics: true,
            reportData: this.state.analyticsData,
            slideIndex: 1,
        });
    }

    render() {
        let loading;
        if (this.state.loadingData) {
            loading = <LinearProgress
                style={DashboardStyles.loader}
                mode="indeterminate"
                color="#E91E63"
            />;
        }else{
            loading = <div></div>;
        }
        var buttonFb = <div></div>;
        if(!this.state.fbConnected) {
            buttonFb = <RaisedButton
                backgroundColor="#4C75BC"
                labelColor="#FFFFFF"
                style={DashboardStyles.searchButton}
                label="Facebook Analytics"
                style={{width: 200}}
                onClick={() => {
                    this.doLoginFB();
                }}
            />;
        }
        return (
            <div className="dashboard-container">
                {loading}
                <Tabs
                    onChange={this.handleChangeTab}
                    value={this.state.slideIndex}
                    tabItemContainerStyle={DashboardStyles.tabBar}
                >
                    <Tab
                        value={0}
                        label="Dashboard"
                        style={{color: 'rgb(76, 117, 188)'}}
                        icon={<DashboardIcon color='rgb(76, 117, 188)'/>}
                    />
                    <Tab
                        value={1}
                        label="Reporte"
                        style={{color: 'rgb(76, 117, 188)'}}
                        icon={<AssignmentIcon color='rgb(76, 117, 188)'/>}
                    />

                </Tabs>
                <SwipeableViews
                  index={this.state.slideIndex}
                  onChangeIndex={this.handleChangeTab}
                  style={{height: window.innerHeight - 175}}
                >
                    <div
                        style={{height: window.innerHeight - 175}}
                    >
                        <div className="dashboard-toolbar-container">
                            <Toolbar style={DashboardStyles.toolbar}>
                                <DatePicker
                                    hintText="Fecha Inicio"
                                    floatingLabelText="Fecha Inicio"
                                    onChange={this.changeInitialDate}
                                    value={this.state.initialDate}
                                    maxDate={moment().toDate()}
                                    // minDate={moment().subtract(92, "days").toDate()}
                                    formatDate={(d) => {
                                        return moment(d).format('DD/MM/YYYY');
                                    }}
                                    disabled={false}
                                    textFieldStyle={{ width: '100%' }}
                                />
                                <DatePicker
                                    hintText="Fecha Fin"
                                    floatingLabelText="Fecha Final"
                                    onChange={this.changeFinalDate}
                                    value={this.state.finalDate}
                                    maxDate={moment().toDate()}
                                    minDate={this.state.initialDate}
                                    formatDate={ (d)=>{
                                        return moment(d).format('DD/MM/YYYY');
                                    }}
                                    disabled={false}
                                />
                                <ToolbarGroup>
                                    <RaisedButton
                                        backgroundColor="#4C75BC"
                                        labelColor="#FFFFFF"
                                        style={DashboardStyles.searchButton}
                                        label="Aplicar"
                                        onClick={this.reloadAnalytics}
                                    />
                                    <RaisedButton
                                        backgroundColor="#565656"
                                        labelColor="#FFFFFF"
                                        style={{ width: 170 }}
                                        label="Enviar a reporte"
                                        onClick={this.sendAnalyticsData}
                                    />
                                </ToolbarGroup>
                            </Toolbar>
                        </div>
                        <GridValues
                            onMergeAnalytics={this.mergeAnalytics}
                            data = {this.state.analyticsData}
                        />
                        {buttonFb}
                    </div>
                    <div
                        style={{height: window.innerHeight - 175}}
                    >
                        <Report
                            onReloadData={this.reloadData}
                            reportData={this.state.reportData}
                            isFromAnalytics={this.state.isFromAnalytics}
                        />
                    </div>
                </SwipeableViews>
            </div>
        );
    }
}

Dashboard.propTypes = propTypes;
Dashboard.defaultProps = defaultProps;

export default Dashboard;



// WEBPACK FOOTER //
// ./src/Components/Dashboard.jsx